// src/pages/Campeonatos.jsx
import React, { useEffect } from "react";
import Layout from "./Layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../features/authSlice.js";
import CampeonatosSection from "../sections/CampeonatosSection";

const Campeonatos = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isError } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError && !user) {
      navigate("/");
    }
  }, [isError, user, navigate]);

  return (
    <>
      <Layout>
        <CampeonatosSection />
      </Layout>
    </>
  );
};

export default Campeonatos;
